const colors = {
  primary: "#906C1C",
};

export default colors;
